import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import * as React from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IApplicationState } from "../store";
import * as messageActions from "../store/message/actions";
import { IMessageQueryResult, IMessageFetchRequest, IMessageContentFetchRequest, IMessage, IMessageTransmissionLog, IVersicherungstraeger, ELDA_UEBERNAHME_STATUS, MESSAGE_DIRECTION, MESSAGE_ORIGIN, TRANSMISSION_STATUS, TRANSMISSION_STATUS_FILTER_ORDER, IRetransmitRequest } from "../store/message";
import { redoIcon, openIcon, ftpLogIcon, responseFileIcon, validationIcon, xmlEditIcon, historyIcon, warningIcon } from "../styles/icons";
import { faRetweet } from '@fortawesome/free-solid-svg-icons';
import LoadingSpinner from "./LoadingSpinner";
import MessageContentModalView from "./MessageContentModalView";
import * as settingActions from "../store/settings/actions";
import { IFrontendSettings } from "../store/settings";

interface IPropertiesFromState {
  data: IMessageQueryResult;
  loading: boolean;
  errors?: string;
  contentLoading: boolean;
  content?: string;
  settings?: IFrontendSettings;
  traeger: IVersicherungstraeger[];
  token: string;
}

interface IPropertiesFromDispatch {
  fetchMessages: typeof messageActions.fetchRequest;
  fetchMessageContent: typeof messageActions.fetchMessageContent;
  retransmitRequest: typeof messageActions.retransmitRequest;
  fetchSettingsRequest: typeof settingActions.fetchRequest;
  fetchTraegerRequest: typeof messageActions.fetchTraegerRequest;
}

interface IMessageListParameters {
  instituteId: number;
}

interface IMessageListState {
  showModal: boolean;
  showFtpLogModal: boolean;
  showResponseFileModal: boolean;
  showValidationModal: boolean;
  showEditXmlModal: boolean;
  showHistoryModal: boolean;
  historyEntries: IMessageTransmissionLog[];
  historyMessage?: IMessage;
  historyError: string;
  ftpLogContent: string;
  responseFileContent: string;
  validationResult: string;
  xmlContent: string;
  currentEditMessage?: IMessage;
  loadingFor?: "ftpLog" | "responseFile" | "validation" | "xml" | "history";
  pageSize: number;
  filterInstitute: number;
  filterTraeger: string;
  filterMart: string;
  filterFileName: string;
  filterFileNr: string;
  filterEldaFileNr: string;
  filterStatus: string;
  filterDateFrom: string;
  filterDateTo: string;
}

class MessageList extends React.Component<IPropertiesFromState & IPropertiesFromDispatch & IMessageListParameters & WithTranslation, IMessageListState> {
  public readonly state: IMessageListState = {
    showModal: false,
    showFtpLogModal: false,
    showResponseFileModal: false,
    showValidationModal: false,
    showEditXmlModal: false,
    showHistoryModal: false,
    historyEntries: [],
    historyMessage: undefined,
    historyError: "",
    ftpLogContent: "",
    responseFileContent: "",
    validationResult: "",
    xmlContent: "",
    loadingFor: undefined,
    pageSize: 20,
    filterInstitute: 0,
    filterTraeger: "",
    filterMart: "",
    filterFileName: "",
    filterFileNr: "",
    filterEldaFileNr: "",
    filterStatus: "",
    filterDateFrom: "",
    filterDateTo: "",
  };

  public componentDidMount() {
    this.props.fetchSettingsRequest();
    this.props.fetchTraegerRequest();
  }

  public render() {
    const { data, loading, errors, t, instituteId, fetchMessages, retransmitRequest, fetchMessageContent, settings, traeger } = this.props;

    const loadPage = (pageNumber: number) => {
      fetchMessages({
        instituteId: instituteId,
        pageSize: this.state.pageSize,
        page: pageNumber,
        filterInstitute: this.state.filterInstitute,
        filterTraeger: this.state.filterTraeger,
        filterMart: this.state.filterMart,
        filterFileName: this.state.filterFileName,
        filterFileNr: this.state.filterFileNr,
        filterEldaFileNr: this.state.filterEldaFileNr,
        filterStatus: this.state.filterStatus,
        filterDateFrom: this.state.filterDateFrom,
        filterDateTo: this.state.filterDateTo
      });
    };

    const applyFilters = () => {
      fetchMessages({
        instituteId: instituteId,
        pageSize: this.state.pageSize,
        page: 0,
        filterInstitute: this.state.filterInstitute,
        filterTraeger: this.state.filterTraeger,
        filterMart: this.state.filterMart,
        filterFileName: this.state.filterFileName,
        filterFileNr: this.state.filterFileNr,
        filterEldaFileNr: this.state.filterEldaFileNr,
        filterStatus: this.state.filterStatus,
        filterDateFrom: this.state.filterDateFrom,
        filterDateTo: this.state.filterDateTo
      });
    };

    const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const newPageSize = parseInt(e.target.value);
      this.setState({ pageSize: newPageSize }, () => {
        fetchMessages({
          instituteId: instituteId,
          pageSize: newPageSize,
          page: 0,
          filterInstitute: this.state.filterInstitute,
          filterTraeger: this.state.filterTraeger,
          filterMart: this.state.filterMart,
          filterFileName: this.state.filterFileName,
          filterFileNr: this.state.filterFileNr,
          filterEldaFileNr: this.state.filterEldaFileNr,
          filterStatus: this.state.filterStatus,
          filterDateFrom: this.state.filterDateFrom,
          filterDateTo: this.state.filterDateTo
        });
      });
    };

    const handleCloseModal = () => {
      this.setState({ showModal: false });
    };

    const openModal = (message: IMessage) => {
      fetchMessageContent({ instituteId: instituteId, message: message });
      this.setState({ showModal: true});
    }

    const openFtpLogModal = async (message: IMessage) => {
      const origin = instituteId === 0 ? 'elda' : 'institute';
      console.log('Opening FTP log modal for message:', message.id, 'origin:', origin, 'token:', this.props.token ? 'present' : 'missing');
      this.setState({ showFtpLogModal: true, loadingFor: "ftpLog", ftpLogContent: "" });
      try {
        const url = `/api/messages/${origin}/${message.id}/ftplog`;
        console.log('Fetching FTP log from:', url);
        const response = await fetch(url, {
          headers: {
            "Authorization": `Bearer ${this.props.token}`,
          },
        });
        console.log('FTP log response status:', response.status, 'ok:', response.ok);
        if (response.ok) {
          const content = await response.text();
          console.log('FTP log content length:', content.length);
          this.setState({ ftpLogContent: content, loadingFor: undefined });
        } else {
          const errorText = await response.text();
          console.error('FTP log error:', response.status, errorText);
          this.setState({ ftpLogContent: `FTP-Log konnte nicht geladen werden. Status: ${response.status}\n${errorText}`, loadingFor: undefined });
        }
      } catch (error) {
        console.error('FTP log fetch error:', error);
        this.setState({ ftpLogContent: `Fehler beim Laden des FTP-Logs: ${error}`, loadingFor: undefined });
      }
    };

    const openResponseFileModal = async (message: IMessage) => {
      const origin = instituteId === 0 ? 'elda' : 'institute';
      console.log('Opening response file modal for message:', message.id, 'origin:', origin);
      this.setState({ showResponseFileModal: true, loadingFor: "responseFile", responseFileContent: "" });
      try {
        const url = `/api/messages/${origin}/${message.id}/responsefile`;
        console.log('Fetching response file from:', url);
        const response = await fetch(url, {
          headers: {
            "Authorization": `Bearer ${this.props.token}`,
          },
        });
        console.log('Response file response status:', response.status, 'ok:', response.ok);
        if (response.ok) {
          const content = await response.text();
          console.log('Response file content length:', content.length);
          this.setState({ responseFileContent: content, loadingFor: undefined });
        } else {
          const errorText = await response.text();
          console.error('Response file error:', response.status, errorText);
          this.setState({ responseFileContent: `Response-Datei konnte nicht geladen werden. Status: ${response.status}\n${errorText}`, loadingFor: undefined });
        }
      } catch (error) {
        console.error('Response file fetch error:', error);
        this.setState({ responseFileContent: `Fehler beim Laden der Response-Datei: ${error}`, loadingFor: undefined });
      }
    };

    const openValidationModal = async (message: IMessage) => {
      const origin = instituteId === 0 ? 'elda' : 'institute';
      this.setState({ showValidationModal: true, loadingFor: "validation", validationResult: "" });
      try {
        const response = await fetch(`/api/messages/${origin}/${message.id}/validate`, {
          headers: {
            "Authorization": `Bearer ${this.props.token}`,
          },
        });
        const content = await response.text();
        this.setState({ validationResult: content, loadingFor: undefined });
      } catch (error) {
        this.setState({ validationResult: `Fehler bei der Validierung: ${error}`, loadingFor: undefined });
      }
    };

    const openEditXmlModal = async (message: IMessage) => {
      const origin = instituteId === 0 ? 'elda' : 'institute';
      console.log('Opening edit XML modal for message:', message.id, 'origin:', origin);
      this.setState({ showEditXmlModal: true, loadingFor: "xml", xmlContent: "", currentEditMessage: message });
      try {
        const url = `/api/messages/${origin}/${message.id}/xml`;
        console.log('Fetching XML from:', url);
        const response = await fetch(url, {
          headers: {
            "Authorization": `Bearer ${this.props.token}`,
          },
        });
        console.log('XML response status:', response.status, 'ok:', response.ok);
        if (response.ok) {
          const content = await response.text();
          console.log('XML content length:', content.length);
          this.setState({ xmlContent: content, loadingFor: undefined });
        } else {
          const errorText = await response.text();
          console.error('XML fetch error:', response.status, errorText);
          this.setState({ xmlContent: `XML konnte nicht geladen werden. Status: ${response.status}\n${errorText}`, loadingFor: undefined });
        }
      } catch (error) {
        console.error('XML fetch error:', error);
        this.setState({ xmlContent: `Fehler beim Laden des XMLs: ${error}`, loadingFor: undefined });
      }
    };

    const openHistoryModal = async (message: IMessage) => {
      const origin = instituteId === 0 ? 'elda' : 'institute';
      this.setState({ showHistoryModal: true, loadingFor: "history", historyEntries: [], historyError: "", historyMessage: message });
      try {
        const response = await fetch(`/api/messages/${origin}/${message.id}/history`, {
          headers: {
            "Authorization": `Bearer ${this.props.token}`,
          },
        });
        if (response.ok) {
          const entries: IMessageTransmissionLog[] = await response.json();
          this.setState({ historyEntries: entries, loadingFor: undefined });
        } else {
          const errorText = await response.text();
          this.setState({ historyError: `${t("pages.messages.history.loadError")} (${response.status}) ${errorText}`, loadingFor: undefined });
        }
      } catch (error) {
        this.setState({ historyError: `${t("pages.messages.history.loadError")} ${error}`, loadingFor: undefined });
      }
    };

    const saveEditedXml = async () => {
      if (!this.state.currentEditMessage) return;
      
      const message = this.state.currentEditMessage;
      const origin = instituteId === 0 ? 'elda' : 'institute';
      console.log('Saving XML for message:', message.id);
      this.setState({ loadingFor: "xml" });
      try {
        const url = `/api/messages/${origin}/${message.id}/xml`;
        
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            "Authorization": `Bearer ${this.props.token}`,
            "Content-Type": "text/plain",
          },
          body: this.state.xmlContent,
        });
        
        if (response.ok) {
          const result = await response.text();
          alert(result);
          this.setState({ showEditXmlModal: false, loadingFor: undefined, currentEditMessage: undefined });
          loadPage(data.pageNumber);
        } else {
          const errorText = await response.text();
          alert(`Fehler beim Speichern: ${errorText}`);
          this.setState({ loadingFor: undefined });
        }
      } catch (error) {
        alert(`Fehler beim Speichern: ${error}`);
        this.setState({ loadingFor: undefined });
      }
    };

    const calculateMessageArrayForPaging = () => {
      const maxPages = 20;
      var startPage = 0;
      var endPage = 0;
      if (data.totalPages <= maxPages) {
        startPage = 1;
        endPage = data.totalPages;
      } else {
        const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
        const maxPagesAfterCurrentPage = Math.floor(maxPages / 2) - 1;
        if (data.pageNumber <= maxPagesBeforeCurrentPage) {
          startPage = 1;
          endPage = maxPages;
        } else if (data.pageNumber + maxPagesAfterCurrentPage >= data.totalPages) {
          startPage = data.totalPages - maxPages + 1;
          endPage = data.totalPages;
        } else {
          startPage = data.pageNumber - maxPagesBeforeCurrentPage;
          endPage = data.pageNumber + maxPagesAfterCurrentPage;
        }
      }
      return Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
    };

    const getStatusEnumKey = (message: IMessage) => {
      if (message.origin === MESSAGE_ORIGIN.ELDA) {
        return `pages.messages.statusEnum.${message.status}`;
      }
      if (message.direction === MESSAGE_DIRECTION.INSTITUTE) {
        return `pages.messages.statusEnum.${message.status}`;
      }
      if (message.eldaMessageStatus) {
        return `pages.messages.statusEnum.${message.eldaMessageStatus}`;
      }
      if (message.status === TRANSMISSION_STATUS.TRANSMIT) {
        return 'pages.messages.statusEnum.WAIT_FOR_MERGE';
      }
      return `pages.messages.statusEnum.${message.status}`;
    };

    const isPartiallyAccepted = (message: IMessage) =>
      message.protokollStatus === ELDA_UEBERNAHME_STATUS.TEILWEISE_UEBERNOMMEN;

    const hasStoredError = (message: IMessage) => {
      if (isPartiallyAccepted(message)) {
        return false;
      }
      return !!message.transmissionError
        || (!!message.protokollStatus && message.protokollStatus !== ELDA_UEBERNAHME_STATUS.UEBERNOMMEN);
    };

    const awaitsEldaConfirmation = (message: IMessage) => {
      const relevantStatus = message.origin === MESSAGE_ORIGIN.INSTITUTE && message.eldaMessageStatus
        ? message.eldaMessageStatus
        : message.status;
      return relevantStatus === TRANSMISSION_STATUS.TRANSMIT
        && message.direction === MESSAGE_DIRECTION.ELDA
        && !message.protokollStatus
        && !message.transmissionError;
    };

    const buildStatusTooltip = (message: IMessage) => {
      const lines: string[] = [];
      lines.push(`${t("pages.messages.statusDetails.ownStatus")}: ${t(`pages.messages.statusEnum.${message.status}`)}`);
      if (message.origin === MESSAGE_ORIGIN.INSTITUTE) {
        lines.push(`${t("pages.messages.statusDetails.eldaStatus")}: ${message.eldaMessageStatus ? t(`pages.messages.statusEnum.${message.eldaMessageStatus}`) : t("pages.messages.statusDetails.notAssigned")}`);
        if (message.eldaMessageFileName) {
          lines.push(`${t("pages.messages.statusDetails.eldaFile")}: ${message.eldaMessageFileName}`);
        }
      }
      lines.push(`${t("pages.messages.statusDetails.protokollStatus")}: ${message.protokollStatus ? message.protokollStatus : t("pages.messages.statusDetails.protokollPending")}`);
      if (message.protokollnummer) {
        lines.push(`${t("pages.messages.statusDetails.protokollnummer")}: ${message.protokollnummer}`);
      }
      lines.push(`${t("pages.messages.statusDetails.transmissionCount")}: ${message.transmissionCount !== undefined && message.transmissionCount !== null ? message.transmissionCount : 0}`);
      lines.push(`${t("pages.messages.statusDetails.lastChange")}: ${moment(message.date).format("DD.MM.YYYY HH:mm:ss")}`);
      if (message.transmissionError) {
        lines.push("");
        lines.push(`${t("pages.messages.statusDetails.error")}: ${message.transmissionError}`);
      }
      return lines.join("\n");
    };

    const shorten = (text: string, maxLength: number) => {
      return text.length <= maxLength ? text : `${text.substring(0, maxLength)}...`;
    };

    const renderStatusSubLine = (message: IMessage) => {
      if (isPartiallyAccepted(message)) {
        return <div style={{fontSize: "11px", color: "#664d03"}}>{t("pages.messages.statusDetails.partiallyAccepted")}</div>;
      }
      if (message.transmissionError) {
        return <div style={{fontSize: "11px", color: "#b02a37"}}>{shorten(message.transmissionError.replace(/\s+/g, " "), 120)}</div>;
      }
      if (message.protokollStatus && message.protokollStatus !== ELDA_UEBERNAHME_STATUS.UEBERNOMMEN) {
        return <div style={{fontSize: "11px", color: "#b02a37"}}>{t("pages.messages.statusDetails.protokollStatus")}: {message.protokollStatus}</div>;
      }
      if (message.protokollStatus === ELDA_UEBERNAHME_STATUS.UEBERNOMMEN) {
        return <div style={{fontSize: "11px", color: "#146c43"}}>{t("pages.messages.statusDetails.acceptedByElda")}</div>;
      }
      if (awaitsEldaConfirmation(message)) {
        return <div style={{fontSize: "11px", color: "#664d03"}}>{t("pages.messages.statusDetails.protokollPending")}</div>;
      }
      return null;
    };

    if (loading) {
      return <LoadingSpinner i18nKey="progress.fetching" />;
    }
    if (errors !== undefined) {
      return <div><b>{t("pages.messages.loadError")}</b></div>
    }
    if (instituteId === -1) {
      return <div>{t("pages.messages.selectOrigin")}</div>
    }
    if (!data || data.empty === true) {
      return <div>{t("pages.messages.noData")}</div>;
    }
    return (
      <div>
        <form
          onSubmit={(e) => { e.preventDefault(); applyFilters(); }}
          style={{marginBottom: "15px", padding: "10px", backgroundColor: "#f5f5f5", borderRadius: "5px"}}
        >
          <div style={{display: "flex", gap: "10px", alignItems: "flex-end", flexWrap: "wrap"}}>
            <div>
              <label style={{display: "block", marginBottom: "5px", fontSize: "12px"}}>{t("pages.messages.filter.traeger")}</label>
              <select
                value={this.state.filterTraeger}
                onChange={(e) => this.setState({filterTraeger: e.target.value})}
                style={{padding: "5px", minWidth: "260px"}}
              >
                <option value="">{t("pages.messages.filter.all")}</option>
                {traeger.map((entry) => (
                  <option key={entry.vstr} value={entry.vstr}>
                    {`${entry.vstr} - ${entry.kurzname} - ${entry.name}`}
                  </option>
                ))}
              </select>
              {traeger.length === 0 &&
                <div style={{fontSize: "11px", color: "#b02a37"}}>{t("pages.messages.filter.traegerLoadError")}</div>
              }
            </div>
            <div>
              <label style={{display: "block", marginBottom: "5px", fontSize: "12px"}}>{t("pages.messages.filter.mart")}</label>
              <input
                type="text"
                value={this.state.filterMart}
                onChange={(e) => this.setState({filterMart: e.target.value})}
                placeholder="z.B. BEW"
                style={{padding: "5px", minWidth: "100px"}}
              />
            </div>
            <div>
              <label style={{display: "block", marginBottom: "5px", fontSize: "12px"}}>{t("pages.messages.filter.fileName")}</label>
              <input
                type="text"
                value={this.state.filterFileName}
                onChange={(e) => this.setState({filterFileName: e.target.value})}
                placeholder="z.B. BEW"
                style={{padding: "5px", minWidth: "150px"}}
              />
            </div>
            <div>
              <label style={{display: "block", marginBottom: "5px", fontSize: "12px"}}>
                {instituteId === 0 ? t("pages.messages.filter.fileNr") : t("pages.messages.filter.fileNrInstitute")}
              </label>
              <input
                type="text"
                inputMode="numeric"
                value={this.state.filterFileNr}
                onChange={(e) => this.setState({filterFileNr: e.target.value.replace(/[^0-9]/g, "")})}
                placeholder="z.B. 1234"
                style={{padding: "5px", minWidth: "110px"}}
              />
            </div>
            {instituteId > 0 &&
              <div>
                <label style={{display: "block", marginBottom: "5px", fontSize: "12px"}}>{t("pages.messages.filter.fileNrElda")}</label>
                <input
                  type="text"
                  inputMode="numeric"
                  value={this.state.filterEldaFileNr}
                  onChange={(e) => this.setState({filterEldaFileNr: e.target.value.replace(/[^0-9]/g, "")})}
                  placeholder="z.B. 1234"
                  style={{padding: "5px", minWidth: "110px"}}
                />
              </div>
            }
            <div>
              <label style={{display: "block", marginBottom: "5px", fontSize: "12px"}}>{t("pages.messages.filter.status")}</label>
              <select
                value={this.state.filterStatus}
                onChange={(e) => this.setState({filterStatus: e.target.value})}
                style={{padding: "5px", minWidth: "120px"}}
              >
                <option value="">{t("pages.messages.filter.all")}</option>
                {TRANSMISSION_STATUS_FILTER_ORDER.map((status) => (
                  <option key={status} value={status}>{t(`pages.messages.statusEnum.${status}`)}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{display: "block", marginBottom: "5px", fontSize: "12px"}}>{t("pages.messages.filter.dateFrom")}</label>
              <input
                type="date"
                value={this.state.filterDateFrom}
                onChange={(e) => this.setState({filterDateFrom: e.target.value})}
                style={{padding: "5px"}}
              />
            </div>
            <div>
              <label style={{display: "block", marginBottom: "5px", fontSize: "12px"}}>{t("pages.messages.filter.dateTo")}</label>
              <input
                type="date"
                value={this.state.filterDateTo}
                onChange={(e) => this.setState({filterDateTo: e.target.value})}
                style={{padding: "5px"}}
              />
            </div>
            <Button variant="primary" type="submit" style={{height: "33px"}}>
              {t("pages.messages.filter.apply")}
            </Button>
            <Button variant="secondary" type="button" onClick={() => {
              this.setState({
                filterInstitute: 0,
                filterTraeger: "",
                filterMart: "",
                filterFileName: "",
                filterFileNr: "",
                filterEldaFileNr: "",
                filterStatus: "",
                filterDateFrom: "",
                filterDateTo: ""
              }, () => {
                fetchMessages({instituteId: instituteId, pageSize: this.state.pageSize, page: 0});
              });
            }} style={{height: "33px"}}>
              {t("pages.messages.filter.reset")}
            </Button>
            <div style={{marginLeft: "auto"}}>
              <label style={{display: "block", marginBottom: "5px", fontSize: "12px"}}>{t("pages.messages.filter.pageSize")}</label>
              <select value={this.state.pageSize} onChange={handlePageSizeChange} style={{padding: "5px"}}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </form>
        <Table striped bordered hover style={{tableLayout: "auto"}}>
          <thead>
            <tr style={{height: "50px"}}>
              <th>{t("pages.messages.date")}</th>
              <th>{t("pages.messages.fileName")}</th>
              <th>{t("pages.messages.traeger")}</th>
              <th>{t("pages.messages.mart")}</th>
              {instituteId === 0 && <th>{t("pages.messages.fileNr")}</th> }
              {instituteId > 0 &&
                <>
                <th>{t("pages.messages.fileNrInstitute")}</th>
                <th>{t("pages.messages.fileNrElda")}</th>
                </>
              }
              <th>{t("pages.messages.direction")}</th>
              <th>{t("pages.messages.status")}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {data && data.elements.map((message) => {
              return (
                <tr key={message.id} style={{height: "50px"}}>
                  <td>{moment(message.date).format("DD.MM.YYYY HH:mm:ss")}</td>
                  <td>{message.fileName}</td>
                  <td title={message.traegerName}>{message.traegerShortname}</td>
                  <td>{message.mart}</td>
                  {instituteId === 0 && <td>{message.fileNr + (message.parted ? " (" + message.messagePart + ")" : "")}</td>}
                  {instituteId > 0 && 
                    <>
                    <td>{message.fileNr + (message.parted ? " (" + message.messagePart + ")" : "")}</td>
                    <td>{message.eldaMessageId ? message.eldaMessageFileNr + (message.parted ? " (" + message.eldaMessagePart + ")" : "") : "-"}</td>
                    </>
                  }
                  <td>{t(`pages.messages.directionEnum.${message.direction}`)}</td>
                  <td title={buildStatusTooltip(message)}>
                    <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                      <span>{t(getStatusEnumKey(message)) + (message.mart !== 'MTT' && message.protokollnummer ? " (" + message.protokollnummer + ")" : "")}</span>
                      {hasStoredError(message) &&
                        <FontAwesomeIcon icon={warningIcon} style={{color: "#b02a37"}} title={t("pages.messages.statusDetails.error")} />
                      }
                      {isPartiallyAccepted(message) &&
                        <FontAwesomeIcon icon={warningIcon} style={{color: "#664d03"}} title={t("pages.messages.statusDetails.partiallyAccepted")} />
                      }
                      {!!message.transmissionCount && message.transmissionCount > 1 &&
                        <span
                          style={{fontSize: "11px", backgroundColor: "#e2e3e5", borderRadius: "8px", padding: "1px 6px"}}
                          title={t("pages.messages.statusDetails.transmissionCount") + ": " + message.transmissionCount}
                        >
                          {"\u21BB" + message.transmissionCount}
                        </span>
                      }
                    </div>
                    {renderStatusSubLine(message)}
                  </td>
                  <td>
                    <div>
                      {((settings && !settings.deleteEdikurMessages) || message.mart === 'MTT') &&
                          <Button variant="link" onClick={() => openModal(message)} title={t("pages.messages.showContent")}>
                            <FontAwesomeIcon icon={openIcon}/>
                          </Button>
                      }
                      {settings && !settings.deleteEdikurMessages &&
                        <>
                          {instituteId > 0 && message.direction === MESSAGE_DIRECTION.INSTITUTE && (message.status === 'TRANSMIT' || message.status === 'ERROR') &&
                            <Button variant="link" onClick={() => retransmitRequest({instituteId: instituteId, message: message, newFileNr: false})} title={t("pages.messages.retransmit")}>
                              <FontAwesomeIcon icon={redoIcon}/>
                            </Button>
                          }
                          {instituteId === 0 && message.direction === MESSAGE_DIRECTION.ELDA && (message.status === 'TRANSMIT' || message.status === 'ERROR') &&
                            <Button variant="link" onClick={() => retransmitRequest({instituteId: 0, message: message, newFileNr: false})} title={t("pages.messages.retransmit")}>
                              <FontAwesomeIcon icon={redoIcon}/>
                            </Button>
                          }
                          {instituteId === 0 && message.direction === MESSAGE_DIRECTION.ELDA && message.status === 'TRANSMIT' &&
                            <Button variant="link" onClick={() => retransmitRequest({instituteId: 0, message: message, newFileNr: true})} title={t("pages.messages.retransmitFresh")}>
                              <FontAwesomeIcon icon={faRetweet}/>
                            </Button>
                          }
                        </>
                      }
                      <Button variant="link" onClick={() => openFtpLogModal(message)} title={t("pages.messages.actions.ftpLog")}>
                        <FontAwesomeIcon icon={ftpLogIcon}/>
                      </Button>
                      <Button variant="link" onClick={() => openResponseFileModal(message)} title={t("pages.messages.actions.responseFile")}>
                        <FontAwesomeIcon icon={responseFileIcon}/>
                      </Button>
                      <Button variant="link" onClick={() => openValidationModal(message)} title={t("pages.messages.actions.validate")}>
                        <FontAwesomeIcon icon={validationIcon}/>
                      </Button>
                      <Button variant="link" onClick={() => openEditXmlModal(message)} title={t("pages.messages.actions.editXml")}>
                        <FontAwesomeIcon icon={xmlEditIcon}/>
                      </Button>
                      <Button variant="link" onClick={() => openHistoryModal(message)} title={t("pages.messages.actions.history")}>
                        <FontAwesomeIcon icon={historyIcon}/>
                      </Button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {data && data.totalPages > 1 && <div>
          <Pagination listClassName="rowNoPadding">
              <PaginationItem disabled={data.firstPage}>
                <PaginationLink first onClick={() => loadPage(0)}/>
              </PaginationItem>
              <PaginationItem disabled={data.firstPage}>
                <PaginationLink previous onClick={() => loadPage(data.pageNumber - 1)}/>
              </PaginationItem>
              {
                calculateMessageArrayForPaging().map((index) => {
                  return (
                    <PaginationItem key={`messagePage_${index}`} active={index === data.pageNumber + 1}>
                      <PaginationLink onClick={() => loadPage(index - 1)}>{index}</PaginationLink>
                    </PaginationItem>
                  );
                })
              }
              <PaginationItem disabled={data.lastPage}>
                <PaginationLink next onClick={() => loadPage(data.pageNumber + 1)}/>
              </PaginationItem>
              <PaginationItem disabled={data.lastPage}>
                <PaginationLink last onClick={() => loadPage(data.totalPages - 1)}/>
              </PaginationItem>
          </Pagination>
        </div>}
        <MessageContentModalView
          content={this.props.content}
          loading={this.props.contentLoading}
          show={this.state.showModal}
          onHide={handleCloseModal}
        />
        <Modal show={this.state.showFtpLogModal} onHide={() => this.setState({ showFtpLogModal: false })} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{t("pages.messages.actions.ftpLog")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingFor === "ftpLog" ? (
              <LoadingSpinner i18nKey="progress.fetching" />
            ) : (
              <pre style={{whiteSpace: "pre-wrap", fontSize: "12px", maxHeight: "600px", overflow: "auto"}}>
                {this.state.ftpLogContent}
              </pre>
            )}
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showResponseFileModal} onHide={() => this.setState({ showResponseFileModal: false })} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{t("pages.messages.actions.responseFile")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingFor === "responseFile" ? (
              <LoadingSpinner i18nKey="progress.fetching" />
            ) : (
              <pre style={{whiteSpace: "pre-wrap", fontSize: "12px", maxHeight: "600px", overflow: "auto"}}>
                {this.state.responseFileContent}
              </pre>
            )}
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showValidationModal} onHide={() => this.setState({ showValidationModal: false })} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{t("pages.messages.actions.validate")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingFor === "validation" ? (
              <LoadingSpinner i18nKey="progress.fetching" />
            ) : (
              <div style={{fontSize: "14px", padding: "10px"}}>
                {this.state.validationResult}
              </div>
            )}
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showHistoryModal} onHide={() => this.setState({ showHistoryModal: false })} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              {t("pages.messages.history.title")}
              {this.state.historyMessage ? ` - ${this.state.historyMessage.fileName}` : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingFor === "history" ? (
              <LoadingSpinner i18nKey="progress.fetching" />
            ) : (
              <>
                {this.state.historyError && <div style={{color: "#b02a37"}}>{this.state.historyError}</div>}
                {!this.state.historyError && this.state.historyEntries.length === 0 &&
                  <div>{t("pages.messages.history.noData")}</div>
                }
                {!this.state.historyError && this.state.historyEntries.length > 0 &&
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>{t("pages.messages.history.date")}</th>
                        <th>{t("pages.messages.history.event")}</th>
                        <th>{t("pages.messages.history.statusChange")}</th>
                        <th>{t("pages.messages.history.file")}</th>
                        <th>{t("pages.messages.history.triggeredBy")}</th>
                        <th>{t("pages.messages.history.detail")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.historyEntries.map((entry) => (
                        <tr key={`${entry.messageOrigin}-${entry.id}`}>
                          <td style={{whiteSpace: "nowrap"}}>{moment(entry.date).format("DD.MM.YYYY HH:mm:ss")}</td>
                          <td style={{whiteSpace: "nowrap"}}>{t(`pages.messages.history.eventEnum.${entry.event}`)}</td>
                          <td style={{whiteSpace: "nowrap"}}>
                            {entry.statusBefore ? t(`pages.messages.statusEnum.${entry.statusBefore}`) : "-"}
                            {" \u2192 "}
                            {entry.statusAfter ? t(`pages.messages.statusEnum.${entry.statusAfter}`) : "-"}
                          </td>
                          <td>
                            {entry.fileName}
                            <div style={{fontSize: "11px", color: "#5a6268"}}>
                              {entry.messageOrigin === "ELDA" ? t("pages.messages.history.sideElda") : t("pages.messages.history.sideInstitute")}
                              {entry.ftpLogId ? ` / FTP-Log ${entry.ftpLogId}` : ""}
                            </div>
                          </td>
                          <td>{entry.triggeredBy}</td>
                          <td style={{whiteSpace: "pre-wrap", fontSize: "12px"}}>{entry.detail}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              </>
            )}
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showEditXmlModal} onHide={() => this.setState({ showEditXmlModal: false })} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>{t("pages.messages.actions.editXml")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingFor === "xml" ? (
              <LoadingSpinner i18nKey="progress.fetching" />
            ) : (
              <div>
                <textarea
                  value={this.state.xmlContent}
                  onChange={(e) => this.setState({ xmlContent: e.target.value })}
                  style={{
                    width: "100%",
                    height: "500px",
                    fontFamily: "monospace",
                    fontSize: "12px",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px"
                  }}
                />
                <div style={{marginTop: "10px", display: "flex", justifyContent: "flex-end", gap: "10px"}}>
                  <Button variant="secondary" onClick={() => this.setState({ showEditXmlModal: false, currentEditMessage: undefined })}>
                    Abbrechen
                  </Button>
                  <Button 
                    variant="primary" 
                    onClick={() => saveEditedXml()}
                  >
                    Speichern
                  </Button>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    data: store.message.data,
    loading: store.message.loading,
    errors: store.message.errors,
    contentLoading: store.message.loadingContent,
    content: store.message.messageContent,
    settings: store.settings.data,
    traeger: store.message.traeger,
    token: store.authentication.token,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchMessages: (request: IMessageFetchRequest) => dispatch(messageActions.fetchRequest(request)),
  retransmitRequest: (request: IRetransmitRequest) => dispatch(messageActions.retransmitRequest(request)),
  fetchMessageContent: (request: IMessageContentFetchRequest) => dispatch(messageActions.fetchMessageContent(request)),
  fetchSettingsRequest: () => dispatch(settingActions.fetchRequest()),
  fetchTraegerRequest: () => dispatch(messageActions.fetchTraegerRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MessageList));
